import React from 'react';

const renderEarlyPayoutsSelectedMarkets = (selectedMarkets, allMarkets) => {
  let str = '';
  for (let i = 0; i < selectedMarkets?.length; i += 1) {
    const selectedMarket = allMarkets?.find((market) => market.id
              === selectedMarkets[i]?.marketId);

    const selectedMarketName = selectedMarket?.name;
    const selectedMarketSelectionName = selectedMarket?.selections
      ?.find((selection) => selection.id
              === selectedMarkets[i]?.selectionId)?.name;

    str += `${selectedMarketName} ${selectedMarketSelectionName}`;

    if (i !== selectedMarkets.length - 1) {
      str += ', ';
    }
  }
  return str;
};

const EarlyPayoutComp = ({ goal, earlyPayoutSelections, markets }) => (
  <>
    <td>
      <div className="d-flex align-items-center justify-content-center">
        <span className="m-l-25"><strong>$</strong></span>
        {' '}
        <span className="w-100">Early Payout</span>
        {' '}
        <span className="timeline__min">{`${goal?.matchMinute}'`}</span>
      </div>
    </td>
    <td>{renderEarlyPayoutsSelectedMarkets(earlyPayoutSelections, markets)}</td>
    <td />
  </>
);

export default EarlyPayoutComp;
